// extracted by mini-css-extract-plugin
export default {"appbar_open":"appbar_appbar_open__O0XnM","appbar_close":"appbar_appbar_close__RWdgW"};